var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-block",class:( _obj = {}, _obj[_vm.formParam] = true, _obj )},[_c('form-select',{attrs:{"name":'from_pref',"label":"出生地","default-no-select":true,"options":_vm.FORM_OPTIONS.from_pref},model:{value:(_vm.from_pref),callback:function ($$v) {_vm.from_pref=$$v},expression:"from_pref"}})],1)
var _obj;}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a4ece99","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/inputParts/InputBlockFromPref.vue
// module id = null
// module chunks = 